(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const roots = new Map();
  const blocks = ['163945028341fb5d84-0', 'large_img_AWcnpd', 'large_img_LGb7cw'];

  function update(root, entries) {
    if (!root.isConnected) {
      roots.delete(root);
      return;
    }
    entries.forEach(({ banner, slot, placeholder }) => {
      if (mobile.matches && !placeholder.isConnected) {
        const box = window.getComputedStyle(slot);
        placeholder.style.width = box.width;
        placeholder.style.minWidth = box.width;
        placeholder.style.height = box.height;
        slot.replaceWith(placeholder);
        slot.classList.add('auratract-mobile-banner-cta');
        banner.append(slot);
      } else if (!mobile.matches && placeholder.isConnected) {
        slot.classList.remove('auratract-mobile-banner-cta');
        placeholder.replaceWith(slot);
      }
    });
  }

  function initialize() {
    document.querySelectorAll('[id^="halo-image-banner-"][id$="__16394502839cbe45cc"]').forEach(root => {
      if (!roots.has(root)) {
        const entries = blocks.flatMap(id => {
          const item = root.querySelector(`.image-banner-item-${id}`);
          const banner = item?.querySelector('.banner-item');
          const content = banner?.querySelector('.content-box');
          const button = content?.querySelector('a.banner-button');
          const slot = button?.parentElement;
          if (!slot || slot.parentElement !== content || slot.children.length !== 1) return [];
          const placeholder = document.createElement('div');
          placeholder.className = 'auratract-mobile-banner-cta-placeholder';
          placeholder.setAttribute('aria-hidden', 'true');
          placeholder.setAttribute('inert', '');
          return [{ banner, slot, placeholder }];
        });
        roots.set(root, entries);
      }
      update(root, roots.get(root));
    });
  }

  mobile.addEventListener('change', () => roots.forEach((entries, root) => update(root, entries)));
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
